import React from 'react';

const JudulTop = () => {
  return (
    <div className="container">
      <h6 className="my-3">Dashboard Stunting Kelurahan Bidara Cina</h6>
    </div>
    // <></>
  );
}

export default JudulTop;
